// Fix for accessibility issues. Issue # VII26-08
import React, { useEffect, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PdfFile from "./PdfFile";
import { useDispatch, useSelector } from "react-redux";
import { loaderSet } from "../../context/actions/loaderAction";
import useDashboardDataForPDF from "./useDashboardDataForPDF";

const DownloadButton = ({
  selectedSchemeOptions,
  investorDetails,
  className = "",
  label = "Download PDF"
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false); // To manage loading state for PDF generation
  const { schemeFundPerformanceDataForPDF,aumDataForSpecificScheme,investorSchemeDetails,schemeOverviewDataForPDF,schemePortfolioData,schemeSectorAllocationData,schemeDocuments } = useDashboardDataForPDF(selectedSchemeOptions);

  const handleLoader = (loading) => {
    if (loading) {
      setIsLoading(true);
      dispatch(loaderSet(true));
    } else {
      setIsLoading(false);
      dispatch(loaderSet(false));
    }
  };

  return (
    <>
      {schemeFundPerformanceDataForPDF && schemeOverviewDataForPDF && schemePortfolioData && schemeSectorAllocationData ? (
        <PDFDownloadLink
          className={className}
          document={
            <PdfFile
              selectedSchemeOptions={selectedSchemeOptions}
              overviewData={schemeOverviewDataForPDF}
              tableData={schemeFundPerformanceDataForPDF}
              investorDetails={investorDetails}
              aumDataForSpecificScheme={aumDataForSpecificScheme}
              investorSchemeDetails={investorSchemeDetails}
              schemePortfolioData={schemePortfolioData}
              schemeSectorAllocationData={schemeSectorAllocationData}
              schemeDocData={schemeDocuments}
            />
          }
          fileName="Investor.pdf"
          aria-label="Download investor report PDF"
          onClick={() => {
            dispatch(loaderSet(true));
            setTimeout(() => {
              dispatch(loaderSet(false));
            }, 1000);
          }}
        >
          {({ loading }) => {
            handleLoader(loading);
            return loading ? "Processing PDF" : label;
          }}
        </PDFDownloadLink>
      ) : (
        <span role="status" aria-live="polite">Processing PDF</span>
      )}
    </>
  );
};

export default DownloadButton;
